
  import {validationHandlerEmailProfile} from "../helpers/fieldsHandler";

  export default {
    name: "ResetPassword",

    data() {
      return {
        fields: {
          email: null
        },
        emailSend: false,
        resendEmail: true,
        timeResend: 60,
        emailErrorMessages: ''
      }
    },
    computed: {
      validateEmail: function () {
        return validationHandlerEmailProfile(this.fields.email)
      }
    },
    methods: {
      async submitForm(){
        if(this.validateEmail.length < 1){
          try {
            await this.$axios.post('/customers/forgot-password', {email: this.fields.email}, {withCredentials: true})
            this.emailSend = true
          }catch (e) {}
        }else{
          this.emailErrorMessages = this.validateEmail
        }
      },
      async resendEmailClick(){
        try {
          await this.$axios.post('/customers/forgot-password', {email: this.fields.email}, {withCredentials: true})
        }catch (e) {}
        this.resendEmail = false
        this.timeResend = 60
        this.changeResendTime()
      },
      focusoutEmailInput (){
        this.emailErrorMessages = this.validateEmail
      },
      changeResendTime(){
        if(this.timeResend > 0) {
          this.timeResend-=1
          setTimeout(this.changeResendTime, 1000)
        }else {
          this.resendEmail = true
        }
      }
    }
  }
